import GroupEventPage from '@layouts/things-to-do/events/group-event-query'

const GroupEvent = (props) => {
  return (
    <GroupEventPage {...props} />
  )
}

GroupEvent.getInitialProps = async ({ query }) => {
  return ({ query })
}

export default GroupEvent
